

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.user', ['squid']).factory('$CheckoutClientDataModel', function ($Model, $Api) {

        return $Model.extend('CheckoutClientDataModel', {

            api: new $Api({
                uri: '/api/user/:id/clientData'
            }),

            merchantIdentityData: function merchantIdentityData() {
                return {
                    email: this.email,
                    brand_name: this.display_name,
                    logo_uri: this.logo_uri,
                    identity_uri: this.identity_uri
                };
            },

            validateClient: function validateClient() {
                if (this.partner_id && this.identity_uri) {
                    return {
                        success: true
                    };
                } else {
                    return {
                        success: false,
                        error: 'invalid_client'
                    };
                }
            },
            validateRedirectUri: function validateRedirectUri(redirectUrl) {
                if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
                    return {
                        success: true
                    };
                } else {
                    return {
                        success: false,
                        error: 'invalid_redirect_url'
                    };
                }
            }
        });
    }).factory('$CheckoutInputDataModel', function ($Model, $Api, $config, $util) {

        var ACTION = {
            login: 'login',
            resolve: 'resolve',
            addCard: 'addCard',
            addBank: 'addBank',
            changeCurrencyConv: 'changeCurrencyConv',
            signup: 'signup',
            mandate: 'mandate',
            addCredit: 'addCredit',
            ulReturn: 'ulReturn',
            creditReturn: 'creditReturn',
            guestCurrencyConversion: 'guestCurrencyConversion'
        };

        return $Model.extend('CheckoutInputDataModel', {

            init: function init() {
                this._super.init.apply(this);
                this.setProperties({
                    client_id: $util.param('client_id'),
                    action: $util.param('action'),
                    redirect_uri: $util.param('redirect_uri'),
                    scope: $util.param('scope'),
                    state: $util.param('state'),
                    flow: $util.param('flow'),
                    payer_id: $util.param('payer_id'),
                    mandate_reference_number: $util.param('mandate_reference_number'),
                    funding_option_id: $util.param('funding_option_id'),
                    locale: $util.param('locale'),
                    logout: $util.param('logout'),
                    refresh_parent: $util.param('refresh_parent'),
                    escape_hatch: $util.param('escape_hatch'),
                    failedBecause: $util.param('failedBecause'),
                    redirectReferrer: $util.param('redirectReferrer'),
                    id_token: $util.param('prox_id'),
                    nonce: $util.param('nonce'),
                    hide_rm: $util.param('hideRM'),
                    payloadEnc: $util.param('payloadEnc'),
                    xcancel: $util.param('x-cancel'),
                    xsuccess: $util.param('x-success')
                });
            },

            api: new $Api({
                baseURI: $config.urls.baseUrl,
                uri: '/api/user/:id/payerId'
            }),

            isEbayTxn: function isEbayTxn() {
                return Boolean(this.client_id);
            },

            validAction: function validAction() {
                var actions = {
                    login: 'login',
                    resolve: 'resolve',
                    addCard: 'addCard',
                    addBank: 'addBank',
                    changeCurrencyConv: 'changeCurrencyConv',
                    signup: 'signup',
                    mandate: 'mandate',
                    addCredit: 'addCredit',
                    ulReturn: 'ulReturn',
                    creditReturn: 'creditReturn',
                    guestCurrencyConversion: 'guestCurrencyConversion'
                };

                return actions.hasOwnProperty(this.action);
            },

            showRYP: function showRYP() {
                return !this.isEbayTxn();
            },

            requiresOAuth: function requiresOAuth() {
                return this.action === ACTION.login || this.action === ACTION.signup;
            },

            requiresRedirectUri: function requiresRedirectUri() {
                return this.action === ACTION.mandate || !this.requiresOAuth();
            },

            validRedirectUri: function validRedirectUri() {
                if (this.requiresRedirectUri()) {
                    return Boolean(this.redirect_uri);
                }
                return true;
            },

            validate: function validate() {
                var error;
                var success = true;

                if (this.isEbayTxn()) {
                    if (!this.validAction()) {
                        success = false;
                        error = 'invalid_action';
                    } else if (!this.validRedirectUri()) {
                        success = false;
                        error = 'invalid_redirect_uri';
                    }
                }

                return {
                    success: success,
                    error: error
                };
            },

            errorUrl: function errorUrl(err, errorDesc) {
                var url = this.redirect_uri;

                url += url && url.indexOf('?') < 0 ? '?' : '&';
                url += 'state=' + encodeURIComponent(this.state);

                if (err) {
                    url += '&error=' + err;
                }
                if (errorDesc) {
                    url += '&error_description=' + errorDesc;
                }

                return url;
            },

            successUrl: function successUrl(code) {
                var url = this.redirect_uri;

                url += url && url.indexOf('?') < 0 ? '?' : '&';
                url += 'state=' + encodeURIComponent(this.state);

                url += '&code=' + code;

                return url;
            },

            rmEnabled: function rmEnabled(featureEnabled) {
                return featureEnabled && this.action === ACTION.login;
            },

            hideRM: function hideRM() {
                return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
            }
        });
    }).factory('$UserInfoModel', function ($Model, $Api) {
        return $Model.extend('UserInfoModel', {
            api: new $Api({
                uri: '/api/user/:id/session'
            })
        });
    }).factory('$ValidatePhoneModel', function ($Model, $Api) {

        return $Model.extend('validatePhoneModel', {
            api: new $Api({
                uri: '/api/user/:token/session/validatePhone',
                cache: false
            })
        });
    }).factory('$AddKYCModel', function ($Model, $Api) {
        return $Model.extend('AddKYCModel', {
            api: new $Api({
                uri: '/api/user/:token/session/addKYC'
            })
        });
    }).factory('$PatchPhoneModel', function ($Model, $Api) {

        return $Model.extend('patchPhoneModel', {
            api: new $Api({
                uri: '/api/checkout/:token/session/patch',
                cache: false
            })
        });
    }).factory('$WaxUserModel', function ($Model, $Api) {
        return $Model.extend('WaxUserModel', {
            api: new $Api({
                uri: '/api/user/:id/waxUser'
            })
        });
    }).factory('$EConsentModel', function ($Model, $Api) {
        return $Model.extend('EConsentModel', {
            api: new $Api({
                uri: '/api/user/eConsent'
            }),

            invalidateOnLogout: true // invalidate this model when auth.logout() gets called
        });
    }).factory('$UserPhotoModel', function ($Model, $Api, $config) {
        return $Model.extend('UserPhotoModel', {
            api: new $Api({
                baseURI: $config.urls.baseUrl,
                uri: 'api/user/photo'
            }),

            invalidateOnLogout: true // invalidate this model when auth.logout() gets called
        });
    }).factory('$AuthConsentModel', function ($Model, $Api) {
        return $Model.extend('AuthConsentModel', {
            api: new $Api({
                uri: '/api/user/authConsent'
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/user/index.js
// module id = ./components/xo-models/src/user/index.js
// module chunks = 1